import { SITUACOES } from './fluxoDoBonusMoradia';

export const LIMITE_DE_DIAS_UTEIS_PARA_PRAZO_A_VENCER = 10;

const ROTULO_DO_BOTAO_PRORROGAR_POR_ESTADO = {
  'a-vencer': 'Prorrogar prazo para envio',
  vencido: 'Prorrogar por 60 dias',
};

const TEXTO_DO_BANNER_POR_ESTADO = {
  vencido: 'Prazo de 120 dias esgotado',
  'vencido-apos-prorrogacao': 'Prazo de 180 dias esgotado',
};

const DESCRICAO_DO_BANNER_POR_ESTADO = {
  vencido:
    'O protocolo do recebimento está bloqueado até a Diretoria Administrativa aprovar uma prorrogação.',
  'vencido-apos-prorrogacao':
    'O prazo prorrogado também venceu. Não há nova prorrogação disponível. A única ação possível é indeferir a solicitação.',
};

const SITUACOES_COM_PRAZO_DO_DOSSIE = [
  SITUACOES.RESERVADO,
  SITUACOES.PRAZO_DOSSIE_VENCIDO,
  SITUACOES.PRAZO_DOSSIE_PRORROGADO,
  SITUACOES.PRAZO_DOSSIE_VENCIDO_PRORROGACAO,
];

export function obterSituacaoDoPrazoDoDossie(status, prazoDoDossie) {
  if (SITUACOES_COM_PRAZO_DO_DOSSIE.indexOf(status) === -1 || !prazoDoDossie) return null;

  const prorrogado = status === SITUACOES.PRAZO_DOSSIE_PRORROGADO;
  const vencido = status === SITUACOES.PRAZO_DOSSIE_VENCIDO;
  const vencidoAposProrrogacao = status === SITUACOES.PRAZO_DOSSIE_VENCIDO_PRORROGACAO;

  const {
    DiasUteisRestantes: diasUteisRestantes,
    DiaAtualDoPrazo: diaAtual,
    TotalDeDiasUteisDoPrazo: totalDeDias,
    PercentualConsumidoDoPrazo: percentualConsumido,
    DataDeVencimentoAtual: dataDeVencimento,
  } = prazoDoDossie;

  let estado;
  if (vencido) estado = 'vencido';
  else if (vencidoAposProrrogacao) estado = 'vencido-apos-prorrogacao';
  else if (prorrogado) estado = 'prorrogado';
  else estado = diasUteisRestantes <= LIMITE_DE_DIAS_UTEIS_PARA_PRAZO_A_VENCER ? 'a-vencer' : 'dentro-do-prazo';

  return {
    estado,
    prorrogado,
    vencido: vencido || vencidoAposProrrogacao,
    diasRestantes: Math.max(diasUteisRestantes, 0),
    diasEmAtraso: Math.max(-diasUteisRestantes, 0),
    diaAtual,
    totalDeDias,
    percentualConsumido,
    dataDeVencimento,
    rotuloBotaoProrrogar: ROTULO_DO_BOTAO_PRORROGAR_POR_ESTADO[estado] || null,
    textoDoBanner: TEXTO_DO_BANNER_POR_ESTADO[estado] || null,
    descricaoDoBanner: DESCRICAO_DO_BANNER_POR_ESTADO[estado] || null,
  };
}



// WEBPACK FOOTER //
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/utils/prazoDoDossie.js